import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../logo.svg';

export default function Nav() {
  const { isLoggedIn } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkStyle = ({ isActive }) => ({
    ...styles.link,
    ...(isActive ? styles.linkActive : {}),
  });

  return (
    <nav style={{ ...styles.nav, ...(scrolled ? styles.navScrolled : {}) }}>
      <div style={styles.inner}>
        <NavLink to="/" style={styles.brand}>
          <span style={styles.brandText}>Camping Spirkenhof</span>
        </NavLink>

        <button
          style={styles.burger}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menü öffnen"
        >
          {menuOpen ? '✕' : '☰'}
        </button>

        <div style={{ ...styles.links, ...(menuOpen ? styles.linksOpen : {}) }}>
          <NavLink to="/" style={linkStyle} onClick={() => setMenuOpen(false)} end>Startseite</NavLink>
          <NavLink to="/galerie" style={linkStyle} onClick={() => setMenuOpen(false)}>Galerie</NavLink>
          <NavLink to="/buchung" style={linkStyle} onClick={() => setMenuOpen(false)}>Buchung</NavLink>
          {isLoggedIn && (
            <NavLink to="/admin" style={linkStyle} onClick={() => setMenuOpen(false)}>Admin</NavLink>
          )}
          <NavLink
            to="/buchung"
            onClick={() => setMenuOpen(false)}
            style={{ ...styles.ctaLink }}
          >
            Jetzt anfragen
          </NavLink>
        </div>
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    background: 'linear-gradient(135deg, #1b4332 0%, #2d6a4f 100%)',
    position: 'sticky',
    top: 0,
    zIndex: 200,
    transition: 'box-shadow 0.3s',
  },
  navScrolled: {
    boxShadow: '0 2px 20px rgba(27,67,50,0.35)',
  },
  inner: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '68px',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.6rem',
    textDecoration: 'none',
  },
  logoImg: {
    height: '44px',
    width: 'auto',
    borderRadius: '6px',
    background: 'white',
    padding: '2px',
  },
  brandText: {
    color: 'white',
    fontWeight: '800',
    fontSize: '1.15rem',
    fontFamily: "'Nunito', Arial, sans-serif",
    letterSpacing: '-0.2px',
  },
  links: {
    display: 'flex',
    gap: '0.25rem',
    alignItems: 'center',
  },
  linksOpen: {},
  link: {
    color: 'rgba(255,255,255,0.82)',
    textDecoration: 'none',
    padding: '0.45rem 0.85rem',
    borderRadius: '8px',
    fontFamily: "'Nunito', Arial, sans-serif",
    fontSize: '0.95rem',
    fontWeight: '600',
    transition: 'background 0.2s, color 0.2s',
  },
  linkActive: {
    color: 'white',
    backgroundColor: 'rgba(255,255,255,0.18)',
  },
  ctaLink: {
    color: '#1b4332',
    textDecoration: 'none',
    padding: '0.5rem 1.1rem',
    borderRadius: '50px',
    fontFamily: "'Nunito', Arial, sans-serif",
    fontSize: '0.9rem',
    fontWeight: '800',
    backgroundColor: '#ffd166',
    marginLeft: '0.5rem',
    transition: 'background 0.2s, transform 0.15s',
  },
  burger: {
    display: 'none',
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '1.4rem',
    cursor: 'pointer',
    padding: '0.3rem',
  },
};
